import MyAccountLinksContainer from './MyAccountLinksContainer.component';

export default MyAccountLinksContainer;